import { render } from "./Actions.vue?vue&type=template&id=79427713&scoped=true"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"

import "./Actions.vue?vue&type=style&index=0&id=79427713&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\bm365\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79427713"]])

export default __exports__